export default __webpack_public_path__ + "static/media/2.6b0cccb2.jpg";